import React, { useState, useEffect } from 'react';
import axiosInstance from '../../Services/axiosCommon';

const UseEqupiProductDropDownNew = (url, search) => {
  const [data, setData] = useState([]);

  async function getData() {
    axiosInstance
      .get(url, { params: { search: search } })
      .then((res) => {
        let data = res.data;
        console.log(data, 'Product Dropdown Response');
        let tempData = [];
        data.forEach((item) => {
          let tempObject = {
            value: item.id,
            name: item.name, // ✅ required for label formatting later
            refNumber: item.refNumber || "", // ✅ ensure it exists
            unit: item.unit || "",
            label: `${item.name || "Unnamed"}`
          };
          tempData.push(tempObject);
        });
        res.data && setData(tempData);
      })
      .catch((err) => {
        console.log(err, 'Product dropdown error');
      });
  }

  useEffect(() => {
    getData();
  }, [url, search]);

  return { data, setData };
};

export default UseEqupiProductDropDownNew;
